module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"gear_title":"Gear","weight_distribution":"Weight distribution","to_profile":"To user profile","chart":"Chart","table":"Table"},"de":{"gear_title":"Ausrüstung","weight_distribution":"Gewichtsverteilung","to_profile":"Zum Nutzerprofil","chart":"Diagramm","table":"Tabelle"}}')
  delete Component.options._Ctor
}
